module.exports = __webpack_public_path__ + "img/1.c3594c04.jpg";